import { t } from "i18next";
import React, { useEffect, useState } from "react";
import SPONSORICON from "../../images/sponsoricon.svg";
import {SponsorContainer} from "../atoms/Cards";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import "../../styles/Common.css";
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  textcontainer: {
    borderRadius: 30,
    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 5,
    paddingBottom: 5,
    backgroundColor: "white",
  },
  iconstyle: {
    width: 60,
    height: 60,
    alignSelf: "center",
    marginBottom: -10,
    marginTop: -30,
    borderRadius: "50%",
  },
  inputstyle1: {
    alignSelf: "center",
    fontFamily: "Lato-SemiBold",
    fontSize: "18px"
  },
};



export default function SponsorMarkerView(props) {
  const [showNotification, setShowNotification] = useState(false);
   const { worldReducer } = useSelector((state) => state);
   useEffect(() => {
     if (worldReducer?.getSponsorChildCoordinates && worldReducer?.getSponsorChildCoordinates?.responseSource === null) {
       if (!worldReducer.getSponsorChildCoordinates?.contactDetailsNotificationTimeStamp) {
         setShowNotification(true);
       } else {
         let currentDate = moment();
         let notificationDate = moment(worldReducer?.getSponsorChildCoordinates?.contactDetailsNotificationTimeStamp);
         let diff = currentDate.diff(notificationDate, "days");
         if (diff > 365) setShowNotification(true);
       }
       // setShowNotification(true);
     }
   }, [worldReducer]);
  return (
    <>
    {props?.soCode === "FINO" ? 
    <OverlayTrigger placement="top" overlay={props?.sponsorID === "" ? <></> : <Tooltip style={{pointerEvents: "none", marginBottom:"5px"}}>{t("SupporterID")} {props?.sponsorID}</Tooltip>}>
      <SponsorContainer style={styles.container} onClick={props?.handleRedirect}>
          <img src={props?.image&&props?.image.length>0?props?.baseURL+props?.image:SPONSORICON} style={styles.iconstyle} alt=""/>
          <div className={`textcontainer ${showNotification ? "textcontainer-notification" : " "}`}>
          {showNotification && <div className="circleupdate">{1}</div>} 
            <span style={styles.inputstyle1}>
              {t("Me")}
            </span>
          </div>
      </SponsorContainer>
    </OverlayTrigger>
    :
    <SponsorContainer style={styles.container} onClick={props?.handleRedirect}>
    <img src={props?.image&&props?.image.length>0?props?.baseURL+props?.image:SPONSORICON} style={styles.iconstyle} alt=""/>
    <div className={`textcontainer ${showNotification ? "textcontainer-notification" : " "}`}>
      {showNotification && <div className="circleupdate">{1}</div>}
        <span style={styles.inputstyle1}>
          {t("Me")}
        </span>
      </div>
  </SponsorContainer>
    }
    </>
  );
}
